import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { PowerResponse} from '../interfaces/beans.interface';
import { Observable, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PowerCatalogService {




  // url = environment.url2 + '/power-attributes';
  url = environment.url2
  constructor(private http: HttpClient) { }

  // getAll(url_path: string){
  //   let headers = new HttpHeaders()
  //   .append('Content-Type', 'application/json')
  //   .append('Autorizzazione', localStorage.getItem('token'));
  //   return this.http.get(`${ this.url+'/'+url_path }/`, { headers }).pipe( map( data => data));
  // }

  add_element(url_path: string,data: any) {
    // const headers = new HttpßHeaders().set('Content-Type', 'application/json');
    console.log("power-catalog-service -> addelement")
    console.log(data.newData)
    data.newData["user"]=localStorage.getItem("userTaxId");
    let body = JSON.stringify(data.newData);
    let headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Autorizzazione', localStorage.getItem('token'));
    // return this.http.post(`${this.url+'/'+url_path}/`,data, { headers }).pipe(
    //   map(data => data));
    return this.http.post(`${this.url+'/'+url_path}/`, body, { headers }).pipe( map( data => data));
  }

  getAll(url_path: string): Observable<PowerResponse> {
    let headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Autorizzazione', localStorage.getItem('token'));
  
    return this.http.get<PowerResponse>(`${this.url+'/'+url_path}/`, { headers });
  }

  getAll2<T = PowerResponse>(url_path: string): Observable<T> {
    let headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Autorizzazione', localStorage.getItem('token'));
  
    return this.http.get<T>(`${this.url+'/'+url_path}/`, { headers });
  }
  


}
